import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { NotificationManager } from "react-notifications";
import UserService from "services/UserService";
import axios from "axios";
import { getMBMDashboard } from "services/ConfigServices";
import { entitiestext, equipmentpagetext, pointtext } from "variables/MBM/connectivity";
import { mbmcriticityData } from "variables/lists/patrimoine";
import { definitionData, fieldprotocoleData, eosprotocoleData, displaymethodData, stateData } from "variables/MBM/lists/equipments";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: -8px;
`;


export default function useEntitiesTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbmadmin = permis.includes("mbm_admin") && currentusertype == 1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMBMDashboard(chartIdGroup, null, 'entities');
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sitesdata, setSitesData] = useState([]);
  const [sites, setSites] = useState([]);

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };


  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      async function fetchData() {
        await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
          .then((res) => {
            setResults(res.data);
            setSitesData(res.data.entities);
            setLoading(false);
          })
          .catch(() => {
            setNotification("error", "Une erreur est survenue");
            setLoading(false);
          });
        ;
        // setResults(response.data);
        // setSitesData(response.data.entities);
        //  setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `entities`, []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
  );


  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = [];
    exportarray = sites.map((item) => {
      let sitetoexport = {};
      sitetoexport[entitiestext.id] = item.id;
      sitetoexport[entitiestext.name] = item.name;
      sitetoexport[entitiestext.path] = item.path;
      sitetoexport[entitiestext.criticiy] = mbmcriticityData.find((x) => x.id == item.mbm?.criticity)?.name || '';
      sitetoexport[entitiestext.connectedequipments] = item.dashboard.equipmentsactives + '/' + (item.dashboard.equipmentsactives + item.dashboard.equipmentsinactives);
      sitetoexport[entitiestext.connectedmediumequipments] = item.dashboard.equipmentsmediumactives + '/' + (item.dashboard.equipmentsmediumactives + item.dashboard.equipmentsmediuminactives);
      sitetoexport[entitiestext.connectedhighequipments] = item.dashboard.equipmentshighactives + '/' + (item.dashboard.equipmentshighactives + item.dashboard.equipmentshighinactives);
      sitetoexport[entitiestext.minbattery] = item.dashboard.minbattery;
      sitetoexport[entitiestext.avgbattery] = item.dashboard.avgbattery;
      sitetoexport[entitiestext.minsignal] = item.dashboard.minsignal;
      sitetoexport[entitiestext.avgsignal] = item.dashboard.avgsignal;
      sitetoexport[entitiestext.mintemp] = item.dashboard.mintemp;
      sitetoexport[entitiestext.avgtemp] = item.dashboard.avgtemp;
      sitetoexport[entitiestext.maxtemp] = item.dashboard.maxtemp;
      return sitetoexport;
    });





    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={(!sites || sites.length < 1)} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, sitesdata, sites]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSites,
    sitesdata,
  };
}
